import { Inject, Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ICustomComponent} from "../shared/interfaces/configuracion";
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class CustomComponentService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/custom-components`;
  }

  getComponentById(id:number, version:number): Observable<ICustomComponent> {
    return this.http.get<ICustomComponent>(`${this.baseUrl}/component/${id}/${version}`);
  }
}
